export default "__VITE_ASSET__CTtaXRJ4__"